import { BCMSRecord, Workflow, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import AddPhoneContent from "components/pages/AdvancedAlertsPage/components/AddPhoneContent";
import VerifyRecipientContent from "components/pages/AdvancedAlertsPage/components/VerifyRecipientContent";
import Classes from "model";

const steps = [ AddPhoneContent, VerifyRecipientContent ];

export default function AdvancedAlertsAddPhoneWorkflow(props) {
    const context = useBCMSContext();
    const { stepID } = useParams();

    BCMSRecord.globalControllerFor(Classes, context);

    return <Workflow steps={ steps } stepID={ stepID } value={ getDefault() } />
}

export const getWorkflowSteps = () => steps;

export const getDefault = () => {
    return {
        "phone": ""
    };
};